import { render } from "./HelloWorld.vue?vue&type=template&id=32666008&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=32666008&scoped=true&lang=css"

import exportComponent from "/Users/sigen/Documents/project/web/haven_color_home/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32666008"]])

export default __exports__